import { Component, OnDestroy, OnInit } from '@angular/core';
import { WebRouletteService } from 'app/public/services/web-roulette.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { CommonService } from 'app/shared/services/common.service';
import { BaseLids } from '../../base-lids';

@Component({
  selector: 'app-lids-mobile',
  templateUrl: './lids-mobile.component.html',
  styleUrls: ['./lids-mobile.component.scss']
})
export class LidsMobileComponent extends BaseLids implements OnInit, OnDestroy {
  displaySidebar: boolean = false;

  constructor(webRouletteService: WebRouletteService, localizationService: LocalizationService, commonService: CommonService) {
    super(webRouletteService, localizationService, commonService)
  }
  ngOnDestroy(): void {
    this.destroy();
  }
  ngOnInit(): void {
    this.init();
    this.loadLids()
  }

}


